"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesforceAuthRedirect = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const constants_1 = require("./constants");
const sendMessage = (message) => {
    if (window?.Office?.context?.ui?.messageParent) {
        window.Office.context.ui.messageParent(JSON.stringify(message));
    }
    else {
        window.opener.postMessage(message, '*');
    }
};
const SalesforceAuthRedirect = () => {
    const [debugInfo, setDebugInfo] = (0, react_1.useState)('Loading...');
    const messageRef = (0, react_1.useRef)(undefined);
    const callback = () => {
        const urlParams = new URLSearchParams(window.location.search || window.location.hash.replaceAll('#', ''));
        const code = urlParams.get('code') || '';
        const state = Number(urlParams.get('state'));
        const message = code
            ? { type: constants_1.AuthRedirectEvent.Salesforce, code, state }
            : undefined;
        if (APPLICATION_TYPE === 'LOCAL') {
            messageRef.current = message;
            setDebugInfo([
                `URL: ${window.location.href}`,
                `has code: ${!!code}`,
                `state: ${state}`,
                `Office available: ${!!window?.Office}`,
                `messageParent available: ${!!window?.Office?.context?.ui?.messageParent}`,
                `window.opener available: ${!!window.opener}`,
                `message: ${JSON.stringify(message)}`,
            ].join('\n'));
            return;
        }
        sendMessage(message);
    };
    (0, react_1.useEffect)(() => {
        if (window?.Office?.onReady) {
            window.Office.onReady(callback);
        }
        else {
            callback();
        }
    }, []);
    if (APPLICATION_TYPE !== 'LOCAL')
        return null;
    return ((0, jsx_runtime_1.jsxs)("div", { style: { padding: 16 }, children: [(0, jsx_runtime_1.jsx)("pre", { style: { fontSize: 12, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }, children: debugInfo }), (0, jsx_runtime_1.jsx)("button", { style: { marginTop: 12, padding: '8px 16px' }, onClick: () => sendMessage(messageRef.current), children: "Send message & close" })] }));
};
exports.SalesforceAuthRedirect = SalesforceAuthRedirect;
